"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationCtaTd = exports.StyledProviderBadge = exports.PhoneFaxNumberTd = exports.AddressTd = exports.PhoneFaxAnchor = exports.LocationRow = exports.LocationAnchor = exports.LocationName = exports.LocationLinkContainer = exports.AvailabilityTd = exports.AvailabilityRow = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const ProviderBadges_styles_1 = require("../../ProviderBadges/ProviderBadges.styles");
exports.AvailabilityRow = (0, styled_1.default)('tr') `
  @media only screen and (max-width: ${(0, ui_theme_1.fromTheme)('screen_medium')}) {
    ${({ shouldHideBelowScreenMedium }) => shouldHideBelowScreenMedium && 'display: none;'}
  }
`;
exports.AvailabilityTd = (0, styled_1.default)('td') `
  ${(_a) => {
    var { isAvailabilityReadOnly } = _a, restProps = __rest(_a, ["isAvailabilityReadOnly"]);
    return isAvailabilityReadOnly
        ? `padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')(restProps)} 0px !important;`
        : `@media only screen and (min-width: ${(0, ui_theme_1.fromTheme)('screen_medium')(restProps)}) {padding: ${(0, ui_theme_1.fromTheme)('spacing_large')(restProps)} 0 !important;}`;
}}
`;
exports.LocationLinkContainer = (0, styled_1.default)('div') `
  display: table;
  table-layout: fixed;
  width: 100%;
`;
exports.LocationName = (0, styled_1.default)('strong') `
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  padding: ${(0, ui_theme_1.fromTheme)('spacing_xsmall')} ${(0, ui_theme_1.fromTheme)('spacing_xsmall')}
    ${(0, ui_theme_1.fromTheme)('spacing_xsmall')} 0;
  display: table-cell;
`;
exports.LocationAnchor = (0, styled_1.default)('a') `
  color: ${(0, ui_theme_1.fromTheme)('color_link')};
  font-weight: bold;
  text-decoration: none;
  display: block;

  &:hover {
    text-decoration: underline;
  }
`;
exports.LocationRow = (0, styled_1.default)('tr') `
  td {
    white-space: nowrap;

    &:first-of-type {
      white-space: normal;
    }
  }
  border-top: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_border')} !important;
`;
exports.PhoneFaxAnchor = (0, styled_1.default)('a') `
  cursor: pointer;

  &,
  &:visited {
    color: ${(0, ui_theme_1.fromTheme)('color_link')};
    text-decoration: none;
  }

  &:hover,
  &:hover:visited {
    color: ${(0, ui_theme_1.fromTheme)('color_link_hover')};
    text-decoration: underline;
  }
`;
exports.AddressTd = (0, styled_1.default)('td') `
  width: auto;
  display: flex;
  align-items: center;
`;
exports.PhoneFaxNumberTd = (0, styled_1.default)('td') `
  width: 130px;
  & > div {
    display: grid;
    grid-template-columns: min-content 1fr;
    grid-gap: ${(0, ui_theme_1.fromTheme)('spacing_small')};
    align-items: center;
  }
`;
exports.StyledProviderBadge = (0, styled_1.default)(ProviderBadges_styles_1.ProviderProfileBadge) `
  @media only screen and (max-width: ${(0, ui_theme_1.fromTheme)('screen_medium')}) {
    margin: ${(0, ui_theme_1.fromTheme)('spacing_medium')} auto;
  }
`;
exports.LocationCtaTd = (0, styled_1.default)('td') `
  width: auto;
`;
//# sourceMappingURL=Location.styles.js.map